module.exports = __webpack_public_path__ + "assets/img/td8.d596b048.png";